"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLWBRetirePayModal = GLWBRetirePayModal;
exports.GLWBStepUpModal = GLWBStepUpModal;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _BenefitBaseDesktopText = _interopRequireDefault(require("./svg/BenefitBaseDesktopText"));
var _BenefitBaseDesktopGraph = _interopRequireDefault(require("./svg/BenefitBaseDesktopGraph"));
var _BenefitBaseMobileGraph = _interopRequireDefault(require("./svg/BenefitBaseMobileGraph"));
var _BenefitBaseMobileText = _interopRequireDefault(require("./svg/BenefitBaseMobileText"));
var _BenefitBaseMobileLegend = _interopRequireDefault(require("./svg/BenefitBaseMobileLegend"));
var _RetirePayDesktopText = _interopRequireDefault(require("./svg/RetirePayDesktopText"));
var _RetirePayDesktopTable = _interopRequireDefault(require("./svg/RetirePayDesktopTable"));
var _RetirePayMobileTable = _interopRequireDefault(require("./svg/RetirePayMobileTable"));
var _BenefitBaseDesktopNoteText = _interopRequireDefault(require("./svg/BenefitBaseDesktopNoteText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function GLWBStepUpModal(_ref) {
  var {
    handleClose,
    show
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "glwb"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Understanding How Step-Ups Impact the RetirePay Benefit Base"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_BenefitBaseDesktopText.default, {
    className: "d-flex justify-content-end"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_BenefitBaseDesktopNoteText.default, {
    className: "d-flex justify-content-end"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_BenefitBaseDesktopGraph.default, {
    className: "d-flex justify-content-end"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-tablet-mobile-only mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("p", null, "The benefit base can grow due to positive market performance. However, it will not decrease due to negative market performance."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "svgrow"
  }, /*#__PURE__*/_react.default.createElement(_BenefitBaseMobileGraph.default, null))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_BenefitBaseMobileLegend.default, null)), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_BenefitBaseMobileText.default, {
    className: "d-flex justify-content-end"
  }))))));
}
function GLWBRetirePayModal(_ref2) {
  var {
    handleClose,
    show
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "glwb"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "The RetirePay Difference"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_RetirePayDesktopText.default, {
    className: "align-top mm-spacing--minor"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_RetirePayDesktopTable.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-tablet-mobile-only mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Unlike traditional GLWBs, RetirePay's roll-up is built into the withdrawal rate table. The withdrawal rate increases in two ways: First, it increases with each year that taking income is deferred. Second, it increases when a new age band on the table is reached.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), "Since RetirePay's roll-up is built into the withdrawal rates and does not increase the benefit base; this design may result in a lower fee compared to other GLWB designs. The RetirePay fee is calculated as a percentage of the benefit base and assessed on the contract value. With other GLWBs, the roll-up is built into the benefit base, resulting in a larger benefit base, and potentially a higher fee."), /*#__PURE__*/_react.default.createElement("div", {
    className: "svgrow"
  }, /*#__PURE__*/_react.default.createElement(_RetirePayMobileTable.default, null)))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, {
    className: "glwb-rpd-link"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Learn more about how RetirePay can provide income for your clients:", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://fieldnet.massmutual.com/public/ann/pdfs/an2739.pdf",
    target: "_blank",
    rel: "noreferrer"
  }, "Retirement Income Planning with MassMutual RetirePay\xA0", /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-sm icon-external-link"
  }))), /*#__PURE__*/_react.default.createElement("p", {
    className: "glwb-rpd-disclosure"
  }, "This chart represents current Single Life withdrawal rates for a contract not issued in New York. There are different withdrawal rates for Single Life and Joint Life versions of RetirePay. Please refer to the Prospectus Rate Sheet for the current withdrawal rates. There is a separate Prospectus Rate Sheet Supplement for contracts issued in New York."))));
}